export default "__VITE_ASSET__VbmA$xAB__"